import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Phone, MessageCircle, Search } from "lucide-react";
import { useSettings, useSEO } from "@/lib/hooks";
import Logo from "@/components/Logo";

export default function RequestConfirmation() {
  const { requestNumber } = useParams();
  const s = useSettings();
  useSEO({ title: `Demande ${requestNumber} — Depann7` });
  return (
    <div className="bg-white min-h-[60vh]">
      <div className="max-w-2xl mx-auto px-4 lg:px-6 py-16 text-center">
        <Logo tone="dark" className="h-11 mx-auto mb-8" />
        <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto">
          <CheckCircle2 className="text-green-600" size={32} />
        </div>
        <h1 className="text-3xl font-extrabold text-txt-900 mt-5">Demande envoyée</h1>
        <p className="text-txt-500 mt-3 max-w-md mx-auto">Votre demande a bien été enregistrée. Notre équipe vous rappelle dans les plus brefs délais.</p>
        <div className="mt-6 bg-brand-50 border border-brand-200 rounded-2xl p-6 inline-block">
          <div className="text-xs text-brand-600 font-medium">Numéro de demande</div>
          <div className="text-3xl font-extrabold text-brand mt-1" data-testid="confirmation-number">{requestNumber}</div>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <a href={`tel:${s?.company_phone_raw || ""}`} className="bg-brand hover:bg-brand-600 text-white font-bold rounded-xl px-6 py-3.5 inline-flex items-center justify-center gap-2 transition-colors"><Phone size={18} /> Appeler maintenant</a>
          <a href={`https://wa.me/${s?.company_whatsapp || ""}?text=Demande%20${requestNumber}`} target="_blank" rel="noreferrer" className="bg-whats hover:bg-whats-hover text-white font-bold rounded-xl px-6 py-3.5 inline-flex items-center justify-center gap-2 transition-colors"><MessageCircle size={18} /> WhatsApp</a>
          <Link to={`/suivi/${requestNumber}`} className="border border-surface-200 text-txt-700 hover:border-brand hover:text-brand font-bold rounded-xl px-6 py-3.5 inline-flex items-center justify-center gap-2 transition-colors"><Search size={18} /> Suivre</Link>
        </div>
      </div>
    </div>
  );
}
